<template>
  <Button class="cart-button"
          type="secondary"
          @click="goToCheckout">
    <template #icon>
      <Icon name="shopping-basket-2-line"/>
    </template>
    <template #default>
      <div>
        {{ t('buttons.basket') }}

        <div v-if="itemAmountInBasket > 0" class="cart-button__notification">
          {{ itemAmountInBasket }}
        </div>
      </div>
    </template>
  </Button>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useLocalizedRouter } from '@/composables/localizedRouter'
import Button from '@/components/partials/Buttons/Button/Button.vue'
import { useCartStore } from '@/stores/useCartStore'
import Icon from "@/components/partials/Icon.vue"

const { t } = useI18n()
const router = useRouter()
const { localizedRoute } = useLocalizedRouter()

async function goToCheckout() {
  await router.push(localizedRoute({ name: 'checkout' }))
}

const cartStore = useCartStore()

const itemAmountInBasket = computed(() => cartStore.basketItems.length ?? 0)
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixins/styling.scss";

.cart-button {
  position: relative;

  &__notification {
    display:       flex;
    align-items:   center;
    justify-content: center;
    width:         1.5rem;
    height:        1.5rem;
    border-radius: 50%;
    position:      absolute;
    top:           -0.25rem;
    right:         -0.25rem;
    @include gradient-button;
    font-size:     0.7rem;
    color:         #ffffff;
    line-height:   100%;
  }
}
</style>
